var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('Header'),_c('router-view',{ref:"router"}),_c('Backtop'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }